import AxiosClient from "../../../services/axios.services";

class CuestionarioServices {
  getCuestionariosById = (id) =>
    AxiosClient.get(`/api/app/Clima_Cuestionario_listado/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
  saveCuestionariosAnswers = (data) =>
    AxiosClient.post(`/api/app/clima_creacion_masivo_respuestas/`, data, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new CuestionarioServices();
